import React from 'react';
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";

const Header = () => {
  return (
    <div className={"leaflet-top leaflet-left"}>
      <div className={"leaflet-control leaflet-bar"}>
        <Card
          style={{
            background:
              "black",
            borderRadius: "0px",
            color: "#ffffff",
            display: 'flex',
            justifyContent: 'center',

          }}
        >
          <CardContent style={{ display: "flex", padding: '5px' }} id={'title-container'}>
            <a href={'https://www.myforecast.com'} className={'mf-anchor'}>
              <div className={'large-font'}>
                <span className={'white-font'}>My</span><span className={'lightblue-font'}>Forecast</span>
              </div>
            </a>
            {/* <div className={'large-font'} style={{ margin: '0px 10px' }}>|</div> */}
            <div className={'large-font model-title'}>
              MyFutureCast
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}

export default Header
